import { SpringConfigsType } from 'interfaces/generic';

type TMgaConfigs = Required<
  Pick<
    SpringConfigsType,
    | 'ADD_INFO_AFTER_LOGIN'
    | 'REALITY_CHECK'
    | 'SELF_EXCLUSION_REASON'
    | 'IS_CASINO_FUN_MODE_UNAVAILABLE'
    | 'MGA_ACCOUNT_TYPE'
    | 'CASINO_BALANCE_IN_USER_BALANCE'
    | 'CASINO_FUN_MODE'
    | 'SHOW_CASINO_TIMER_NET_WIN'
  >
>;

export default {
  ADD_INFO_AFTER_LOGIN: true,
  REALITY_CHECK: true,
  SELF_EXCLUSION_REASON: true,
  IS_CASINO_FUN_MODE_UNAVAILABLE: true,
  MGA_ACCOUNT_TYPE: true,
  CASINO_BALANCE_IN_USER_BALANCE: true,
  CASINO_FUN_MODE: false,
  SHOW_CASINO_TIMER_NET_WIN: true
} as TMgaConfigs;
